if (!customElements.get('timond-shipping-policy')) {
  customElements.define('timond-shipping-policy', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.scope = this.closest('.shopify-section');
      this.scope?.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname !== this.dataset.policyPath || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.opener = link;
        if (!this.dialog.open) this.dialog.showModal();
      }, options);
      this.querySelector('[data-policy-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', event => {
        event.stopPropagation();
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !event.isComposing) {
          event.preventDefault();
          event.stopPropagation();
          this.dialog.close();
        }
      }, options);
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
